import { ChatTitle } from "../../Spark/SparkSidebarSection/SidebarChatList";
import { useSpectraSparks } from "../../../api/queryHooks";
import UserAuthStore from "../../../store/userStore";
import { useTheme } from "../../../context/ThemeProvider";

const SparkSpectraListing = ({ space }) => {
  const user = UserAuthStore((state) => state.user);
  const orgId = UserAuthStore((state) => state.orgId);
  const { theme } = useTheme();

  // Use React Query for data fetching - read directly without Zustand sync
  const { data: sparksData, isLoading } = useSpectraSparks(
    space.space_id,
    orgId,
    user?.uid,
    space.owner_id,
    { enabled: !!user?.uid && !!orgId && !!space.space_id }
  );

  // Extract chats directly from React Query
  const chats = sparksData?.success && sparksData.sparks 
    ? sparksData.sparks 
    : sparksData && !sparksData.success 
      ? [] 
      : undefined;

  return (
    <div
      className="mb-[10px] overflow-hidden"
      style={{ animation: "spectraExpand 0.2s ease-out" }}
    >
      {isLoading || chats === undefined ? (
        <div className="min-h-[40px] pt-[5px] pb-[15px] text-center text-xs dark:text-ink-hex-aaaaaa text-ink-copy-hover">
          Loading...
        </div>
      ) : chats.length === 0 ? (
        <div className="min-h-[40px] pt-[5px] pb-[15px] text-center text-sm italic opacity-100 dark:text-ink-hex-aaaaaa text-ink-copy-hover">
          Add or move spark here...
        </div>
      ) : (
        <div className="pl-[4px] border-l border-edge-border dark:border-edge-muted-control ml-[5px]">
          <ul className="flex flex-col gap-2">
            {chats.map((chat) => (
              <ChatTitle
                key={chat.uid}
                chat={chat}
                space={space}
                theme={theme}
              />
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SparkSpectraListing;
